import { Factory } from '../Factory';
import { BaseOAuthService } from './BaseOAuthService';

export class DropboxOAuthService extends BaseOAuthService {
  constructor(httpService, configService) {
    super(httpService, configService);
  }

  protected getAuthUrlRelativeUri(): string {
    return "/oauth/dropbox/authorization/url";
  }

  protected getAuthTokenRelativeUri(): string {
    return "/oauth/dropbox/authorization/token";
  }
}

frontendApp.factory("DropboxOAuthService", ['HttpService', 'ConfigService', Factory.Create(DropboxOAuthService)]);
